import { GridYValue } from '../constants';

// Grid rows the constructor canvas keeps under its lowest field, so a form
// never ends flush against its last element.
export const CANVAS_BOTTOM_ROWS = 3;

// Room kept below the field being dragged, so there is always canvas left under
// the pointer to drop it on. The canvas ends a few rows under the lowest field,
// which is exactly where a field dragged downwards is heading: without this the
// drop target runs out from under the pointer, react-dnd stops reporting the
// drag, and the field cannot be moved past the bottom of the form.
export const DRAG_HEADROOM_PX = 400;

// Where a field's box ends on the canvas, in pixels from the top of the form
// area, including the bottom rows the canvas keeps under it.
export const getFieldCanvasBottom = ({ top, height }) => (top + height + CANVAS_BOTTOM_ROWS) * GridYValue;

// The height the canvas needs to show every field it holds.
export const getContentCanvasHeight = (fields) =>
  fields.length ? Math.max(...fields.map((field) => getFieldCanvasBottom(field.options))) : 0;

// The height the canvas needs while `position` is being dragged: the field's own
// bottom plus the headroom that keeps the drop target alive below it.
export const getDragCanvasHeight = (position) => getFieldCanvasBottom(position) + DRAG_HEADROOM_PX;

// The first grid row clear of the form title. A field is drawn from two rows
// above its `top` (the room its padding takes), and the title fills the top
// 100px of the canvas, so this is where the first field of a form has always gone.
export const FIELDS_TOP_ROW = 12;

// The room a field keeps around its content, in grid units: two rows above it
// and 2% on either side (`padding: 20px 2%` on the field box).
const FIELD_PADDING = 2;

// The width a field is assumed to need when it has none of its own yet (a
// checkbox list, a table, a link...): those shrink to fit their content, so all
// a drop can do is leave them a reasonable amount of room before the right edge.
const UNSIZED_FIELD_WIDTH = 25;

// Where a field taken from the components sidebar lands: wherever it was let go
// of. `dropPoint` is the top-left corner of the dragged component, in pixels
// from the top-left corner of the canvas, which becomes the top-left corner of
// the new field's box. The field is then pushed back inside the form, below the
// title and clear of the left and right edges; the canvas grows to fit it below.
export const getDropPlacement = ({ x, y, areaWidth }, width) => {
  const fieldWidth = typeof width === 'number' ? width : UNSIZED_FIELD_WIDTH;
  const maxLeft = Math.max(100 - FIELD_PADDING - fieldWidth, FIELD_PADDING);

  const top = Math.max(Math.round(y / GridYValue) + FIELD_PADDING, FIELDS_TOP_ROW);
  const left = Math.min(Math.max(Math.round((x / areaWidth) * 100) + FIELD_PADDING, FIELD_PADDING), maxLeft);

  return { top, left };
};
